import { render } from "./AddDimension.vue?vue&type=template&id=130d1fb0&ts=true"
import script from "./AddDimension.vue?vue&type=script&lang=ts"
export * from "./AddDimension.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__